/**
 * Opseg datuma za kalendar (lokalna zona). Monday = početak nedelje.
 * @param {Date} anchorDate
 * @param {'day' | 'week' | 'month'} mode
 * @returns {{ startDate: string, endDate: string }} ISO stringovi za API
 */
export function computeCalendarRange(anchorDate, mode) {
  const d = anchorDate instanceof Date ? new Date(anchorDate) : new Date(anchorDate);
  if (Number.isNaN(d.getTime())) {
    const now = new Date();
    return computeCalendarRange(now, mode);
  }

  if (mode === 'day') {
    const start = new Date(d);
    start.setHours(0, 0, 0, 0);
    const end = new Date(d);
    end.setHours(23, 59, 59, 999);
    return { startDate: start.toISOString(), endDate: end.toISOString() };
  }

  if (mode === 'week') {
    const dayOfWeek = d.getDay();
    const diff = dayOfWeek === 0 ? -6 : 1 - dayOfWeek;
    const start = new Date(d);
    start.setDate(d.getDate() + diff);
    start.setHours(0, 0, 0, 0);
    const end = new Date(start);
    end.setDate(start.getDate() + 6);
    end.setHours(23, 59, 59, 999);
    return { startDate: start.toISOString(), endDate: end.toISOString() };
  }

  if (mode === 'month') {
    const year = d.getFullYear();
    const month = d.getMonth();
    const start = new Date(year, month, 1, 0, 0, 0, 0);
    const end = new Date(year, month + 1, 0, 23, 59, 59, 999);
    return { startDate: start.toISOString(), endDate: end.toISOString() };
  }

  return computeCalendarRange(d, 'week');
}
